const CREDIT_MESSAGES_BY_CODE = {
  ai_credit_exhausted: "Your AI credit is exhausted.",
  ai_credit_insufficient: "You don't have enough AI credit for this request.",
}
const CREDIT_MESSAGES_BY_NORMALIZED_TEXT = new Map([
  ["ai credit is exhausted", CREDIT_MESSAGES_BY_CODE.ai_credit_exhausted],
  ["your ai credit is exhausted", CREDIT_MESSAGES_BY_CODE.ai_credit_exhausted],
  [
    "you don't have enough ai credit for this request",
    CREDIT_MESSAGES_BY_CODE.ai_credit_insufficient,
  ],
])

function errorMessage(error) {
  return typeof error === "string" ? error : error?.message
}

function normalizedMessage(error) {
  return errorMessage(error)?.trim().replace(/\.$/, "").toLowerCase()
}

export function aiCreditLimitMessage(error) {
  return CREDIT_MESSAGES_BY_CODE[error?.payload?.error]
    || CREDIT_MESSAGES_BY_NORMALIZED_TEXT.get(normalizedMessage(error))
}
